import React from "react";

import {
  FaFileExcel,
  FaSearch,
  FaSortAlphaDown,
  FaSortAlphaUp,
  FaTimes,
} from "react-icons/fa";

export default function UsersFilters({
  filters,
  roleOptions,
  loading,
  exportingExcel,
  onExportExcel,
}) {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      {/* Filtres principaux */}
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {/* Recherche */}
        <div className="relative md:col-span-2">
          <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            value={filters.searchTerm}
            onChange={(event) =>
              filters.setSearchTerm(
                event.target.value,
              )
            }
            placeholder="Nom, prénom, email, club ou acteur…"
            className="h-11 w-full rounded-2xl border border-slate-300 bg-white pl-10 pr-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </div>

        {/* Rôle */}
        <select
          value={filters.selectedRole}
          onChange={(event) =>
            filters.setSelectedRole(
              event.target.value,
            )
          }
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
        >
          {roleOptions.map((role) => (
            <option
              key={role.id}
              value={role.id}
            >
              {role.label}
            </option>
          ))}
        </select>

        {/* Date création */}
        <select
          value={filters.recentFilter}
          onChange={(event) =>
            filters.setRecentFilter(
              event.target.value,
            )
          }
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
        >
          <option value="">
            Tous les comptes
          </option>

          <option value="7">
            7 derniers jours
          </option>

          <option value="30">
            30 derniers jours
          </option>

          <option value="90">
            90 derniers jours
          </option>

          <option value="365">
            12 derniers mois
          </option>

          <option value="year">
            Cette année
          </option>
        </select>

        {/* Badge imprimé */}
        <select
          value={
            filters.coachBadgePrintedFilter
          }
          onChange={(event) =>
            filters.setCoachBadgePrintedFilter(
              event.target.value,
            )
          }
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
        >
          <option value="">
            Impression : tous
          </option>

          <option value="true">
            Badge imprimé
          </option>

          <option value="false">
            Badge non imprimé
          </option>
        </select>

        {/* Badge réceptionné */}
        <select
          value={
            filters.coachBadgeReceivedFilter
          }
          onChange={(event) =>
            filters.setCoachBadgeReceivedFilter(
              event.target.value,
            )
          }
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
        >
          <option value="">
            Réception : tous
          </option>

          <option value="true">
            Badge réceptionné
          </option>

          <option value="false">
            Badge non réceptionné
          </option>
        </select>

        {/* Tri */}
        <button
          type="button"
          onClick={filters.toggleSort}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          {filters.sortAsc ? (
            <FaSortAlphaDown />
          ) : (
            <FaSortAlphaUp />
          )}

          {filters.sortAsc
            ? "A → Z"
            : "Z → A"}
        </button>

        {/* Export */}
        <button
          type="button"
          onClick={onExportExcel}
          disabled={
            loading ||
            exportingExcel
          }
          className="inline-flex h-11 items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:opacity-50"
        >
          <FaFileExcel />

          {exportingExcel
            ? "Export…"
            : "Exporter Excel"}
        </button>
      </div>

      {/* Réinitialisation */}
      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={
            filters.resetFilters
          }
          disabled={loading}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaTimes />
          Réinitialiser les filtres
        </button>
      </div>
    </div>
  );
}